import { USER_STATE } from '@shared/ipc/GlobalStateUtils.ts'
import { User } from '@highlight/common'
import { atomWithGlobalState } from '@highlight/ipc/jotai'
import { useAtomValue } from 'jotai'

const userAtom = atomWithGlobalState<User | undefined>(USER_STATE, undefined)

export const useUser = () => {
  return useAtomValue(userAtom)
}
